// noinspection JSUnresolvedReference

import styled, { css } from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

// noinspection DuplicatedCode
export const StockItem = styled.div`
    display: flex;
`
export const StockColorChar = styled.div`
    ${(props) => {
        // noinspection JSUnresolvedReference
        if (props.metroColor === 'shabalovka') {
            {
                return 'color: #ff8103'
            }
        } else if (props.metroColor === 'darkblue') {
            {
                return 'color: #283981'
            }
        } else if (props.metroColor === 'domoded') {
            {
                return 'color: #029a55'
            }
        } else if (props.metroColor === 'vernads') {
            {
                return 'color: #b1d332'
            }
        } else if (props.metroColor === 'maryno') {
            {
                return ' color: #b1d332'
            }
        } else if (props.metroColor === 'varshav') {
            {
                return 'color: #5091bb'
            }
        } else if (props.metroColor === 'sokol') {
            {
                return 'color: #029a55'
            }
        } else if (props.metroColor === 'butovo') {
            {
                return 'color: #85d4f3'
            }
        } else if (props.metroColor === 'orange') {
            {
                return 'color: #ff8103'
            }
        } else if (props.metroColor === 'kolomenskaya') {
            {
                return 'color: #029a55'
            }
        } else if (props.metroColor === 'saddlebrown') {
            {
                return 'color: #945340'
            }
        } else if (props.metroColor === 'yellow') {
            {
                return 'color: #ffd803'
            }
        } else if (props.metroColor === 'darkgreen') {
            {
                return 'color: #029a55'
            }
        } else if (props.metroColor === 'red') {
            {
                return 'color: #ef1e25'
            }
        } else if (props.metroColor === 'lightgreen') {
            {
                return 'color: #b1d332'
            }
        } else if (props.metroColor === 'lightblue') {
            {
                return 'color: #85d4f3'
            }
        } else if (props.metroColor === 'black') {
            {
                return 'color: black'
            }
        } else if (props.metroColor === 'medblue') {
            {
                return 'color: #5091bb'
            }
        } else if (props.metroColor === 'purple') {
            {
                return 'color: #b61d8e'
            }
        } else if (props.metroColor === 'gray') {
            {
                return 'color: #acadaf'
            }
        } else if (props.metroColor === 'aquablue') {
            {
                return 'color: #019ee0'
            }
        } else {
            {
                return 'color: black'
            }
        }
    }};
    font-weight: bold;
    margin-right: 0.4rem;
`
export const StockTitle = styled.a`
    white-space: nowrap;
    color: inherit;
    font: inherit;
    ${(props) =>
        props.isHover &&
        css`
            :hover {
                color: ${ThemeColors.getGreenColor(1)};
            }
        `}
`
